export enum ColumnFilterType {
  NONE,
  STRING,
  INT,
  NUMBER,
  BOOLEAN,
  DATE,
  DATETIME,
  TIME,
  ENUM,
  PERCENTAGE,
  USER,
  BRANCH,
  CLIENT,
  CLIENTID,
  ACCOUNT,
  ACCOUNTID,
  TRADERGROUP,
  SALESGROUP,
  CURRENCY,
  CURRENCY_PAIR,
  CURRENCY_PAIR_GROUP,
  RATE_SOURCE,
  CHANNEL,
  ORDERSTATE,
  ORDERTYPE,
  DEALSTATE,
  FIXCODE,
  AUTO_ELIGIBLE,
  TEMPERATURE,
  DATE_TENOR,
  AGGREGATION,
  BM_FIXCODE,
  FIXING_DATE,
  ALGO_PARAMETERS,
  CATEGORY,
  COMPOSITE_ENUM,
}
